export const Password = (props) => {
    const { password, setPassword } = props;
    return (
        <div className="row">
            <label className="label" htmlFor="password">Password (min 8 caracters)</label>
            <input type="password" id="password" name="password" defaultValue={password} minLength="8" onChange={(e) => setPassword(e.target.value)} required />
            <input type="checkbox" onClick={() => {
                let x = document.getElementById("password");
                x.type === "password" ? x.type = "text" : x.type = "password";
            }} />show
        </div>
    )
}
